import { Button, Col, Row } from 'antd';
import Card from 'antd/es/card';
import { useTranslation } from 'react-i18next';
import { CheckSquareFilled } from '@ant-design/icons';
import style from './ProfileRestyle.module.css';

function PremiumAtameken() {
  const { t } = useTranslation();

  return (
    <>
      <div style={{ fontSize: 24, fontWeight: 'bold' }}>
        Премиум-поддержка от «Атамекен»
      </div>
      <div>
        Единая система защиты, поддержки и развития вашего бизнеса — на всех
        уровнях.
      </div>
      <div style={{ marginTop: 20, fontSize: 18 }}>
        <CheckSquareFilled style={{ color: '#52c41a', marginRight: 5 }} />
        Что вы получаете
      </div>
      <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
        <Col span={12}>
          <Card title={t('Бсплатные услуги')} style={{ height: '100%' }}>
            <div>
              Национальная палата представляет интересы всего бизнес-сообщества,
              предоставляя услуги, которые укрепляют предпринимательскую
              экосистему:
            </div>
            <div style={{ marginTop: 20, fontWeight: 600 }}>Что включено:</div>
            <ul className={style.atameken_list}>
              <li>
                <b>Защита и представительство:</b> в Правительстве, Парламенте,
                акиматах, судах, госорганах и международных структурах
              </li>
              <li>
                <b>Аналитика и влияние:</b> участие в законотворчестве,
                экспертиза проектов, национальные рейтинги и мониторинг
              </li>
              <li>
                <b>Нефинансовая поддержка:</b> инфраструктура, цифровые
                платформы, образовательные и кадровые инициативы
              </li>
              <li>
                <b>Международное продвижение:</b> участие в выставках, торговые
                партнёры, экспортные услуги
              </li>
            </ul>
          </Card>
        </Col>
        <Col span={12}>
          <Card
            title={t('Платные услуги – Сервис 360°')}
            style={{ height: '100%' }}
          >
            <div>
              Один платёж в год — доступ к дополнительным сервисам и
              персонализированной поддержке.
            </div>
            <div>
              <div
                style={{
                  fontSize: 24,
                  display: 'inline-block',
                }}
              >
                2 МЗП
              </div>{' '}
              в год
            </div>
            <Button style={{ width: '100%' }}>Купить</Button>
            <div style={{ marginTop: 20, fontWeight: 600 }}>
              Бесплатные услуги и:
            </div>
            <ul className={style.atameken_list}>
              <li>
                <b>Сопровождение инвестиционных проектов:</b> отображение на
                Инвесткарте, помощь в решении проблем
              </li>
              <li>
                <b>Аналитика по закупкам:</b> интеграция с базами (госзакуп,
                Самрук, ТШО и др.), анализ спроса и конкурентов
              </li>
              <li>
                <b>Отраслевая аналитика:</b> персональные уведомления и
                рекомендации по поддержке и изменениям в ОКЭД
              </li>
              <li>
                <b>Подбор господдержки:</b> автоматическая фильтрация
                инструментов, консультации и обратная связь
              </li>
              <li>
                <b>Правовая поддержка:</b> приоритетное рассмотрение обращений,
                сопровождение в суде и госорганах
              </li>
              <li>
                <b>Консалтинг по ВЭД:</b> экспорт, сертификация, логистика,
                участие в B2B и международных выставках
              </li>
            </ul>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default PremiumAtameken;
